import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import BlockAlignmentUI from './ui';

const BlockAlignmentControl = props => {
  return createElement(BlockAlignmentUI, _extends({}, props, {
    isToolbar: false
  }));
};

const BlockAlignmentToolbar = props => {
  return createElement(BlockAlignmentUI, _extends({}, props, {
    isToolbar: true
  }));
};
/**
 * @see https://github.com/WordPress/gutenberg/blob/HEAD/packages/block-editor/src/components/block-alignment-control/README.md
 */


export { BlockAlignmentControl, BlockAlignmentToolbar };
//# sourceMappingURL=index.js.map